/*!

=========================================================
* Black Dashboard React v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import { Provider } from "react-redux"

import AdminLayout from "layouts/Admin/Admin.js";

import "assets/scss/black-dashboard-react.scss";
import "assets/scss/black-dashboard-react/custom/_spinner.scss"
import "assets/demo/demo.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./tailwind.css";
// Import Webpack 5 fixes LAST to ensure they override everything
import "assets/scss/black-dashboard-react/custom/webpack5-cascade-fixes.scss";

import ThemeContextWrapper from "./components/ThemeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "./components/BackgroundColorWrapper/BackgroundColorWrapper";

const initialState = {
  auth: 0
};

function reducer(state = initialState, action){
  switch (action.type){
    case "LOGIN":
      // console.log("AUTH LOGIN")
      return {
        ...state,
        auth: 1
      };
    case "LOGOUT":
      return {
        ...state,
        auth: 0
      };
    case "USERIMG":
      return {
        ...state,
        imgURL: action.url
      };
    case "USERID":
      // console.log("props updated: " + action.id)
      return {
        ...state,
        userID: action.id
      }
    default:
      // console.log("RETURNING STATE")
      return state;
  }
}

const store = configureStore({ 
  reducer
});

// Expose store to window for debugging
window.store = store;

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ThemeContextWrapper>
    <BackgroundColorWrapper>
      <BrowserRouter>
        <Switch>
          <Provider store={store}>
            <Route path="/" render={(props) => <AdminLayout {...props} />} />
            {/*<Redirect from="/" to="/dashboard" />*/}
            {/*<Redirect from="/user" to="/admin/user" />*/}
          </Provider>
        </Switch>
      </BrowserRouter>
    </BackgroundColorWrapper>
  </ThemeContextWrapper>
);